import { render, staticRenderFns } from "./ChatMessageComponent.vue?vue&type=template&id=7e326b03"
import script from "./ChatMessageComponent.vue?vue&type=script&lang=ts"
export * from "./ChatMessageComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports